import { useState } from "react"
import { Box, Stack } from "@mui/material"

export function RevertButton({...params}){

    let handleRevertClick = params.handleRevertClick
    let title = params.title
    let stateObject = params.stateObject

    let [revertButtonState, setRevertButtonState] = useState('default')

    let revertPaths = {
        default: "/icons/icons-shared/icon-revert-default.svg",
        edited: "/icons/icons-shared/icon-revert-edited.svg",
        hover: "/icons/icons-shared/icon-revert-hover.svg",
        inactive: "/icons/icons-shared/icon-revert-inactive.svg",
        uneditable: "/icons/icons-shared/icon-revert-uneditable.svg",
    }

    const handleButtonHover = (event) => {
        event.preventDefault()
        setRevertButtonState('hover')
    }

    const handleButtonMouseOut = (event) => {
        event.preventDefault()
        setRevertButtonState('default')
    }


    let imagePath = ''
    if (!stateObject[title].lockState){
        if (revertButtonState === 'hover'){imagePath = revertPaths.hover}
        else if (stateObject[title].updatedState && revertButtonState !== 'hover'){imagePath = revertPaths.edited}
        else if (!stateObject[title].updatedState && revertButtonState !== 'hover'){imagePath = revertPaths.default}
    }

    else if (stateObject[title].lockState){
        if (revertButtonState === 'hover'){imagePath = revertPaths.hover}
        else {imagePath = revertPaths.inactive}
    }


    return (
        <Stack direction={'column'} justifyContent={'center'} zIndex={9}
            onMouseOut={(event) => handleButtonMouseOut(event)} 
            onMouseOver={(event) => handleButtonHover(event)}
            onMouseDown={(event) => handleRevertClick(event)}>

            <Box component="img" src={imagePath} width={'20px'} height={'20px'} className={"RevertButton"}/>
        </Stack>
    )
}
